import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
  activateModule,
  fetchAllModules,
  fetchApartmentSettings,
  fetchContracts,
  fetchCustomCheckins,
  fetchCustomEmails,
  fetchSettingsLocalChannex,
  fetchV3AllLocals,
  putSettingsLocalChannex,
} from "../../shared/queries";
import { useTranslation } from "react-i18next";
import FormField from "../FormField";
import SelectInput from "../SelectInput";
import { BaseSelectItem, LocalTable, ModalView } from "../../types";
import { getOptionList, times } from "../../shared/utils/formatting";
import { moduleId } from "../../shared/utils/config";
import Checkbox from "../Checkbox";
import dayjs from "dayjs";
import PaystaySelector from "../integration/channel-selector/PaystaySelector";
import CitytaxSelector from "../integration/channel-selector/CitytaxSelector";
import DepositSelector from "../integration/channel-selector/DepositSelector";
import DocumentSelector from "../integration/channel-selector/DocumentSelector";
import { toast } from "react-toastify";
import Button from "../Button";
import Icon from "../Icon";
import Modal from "../Modal";
import ModalCard from "../ModalCard";
import ModalSection from "../ModalSection";
import ModuleCard from "../module/ModuleCard";
import ModalActions from "../ModalAction";
import TextInput from "../TextInput";

type Props = {
  local_key: string;
  rate_plan_id?: any;
  onGoBack?: () => void;
  onSuccessMutation?: () => void;
  refetchLocalList?: () => void;
};

const EditRoomSettings = (props: Props) => {
  const {
    local_key,
    rate_plan_id,
    onGoBack,
    onSuccessMutation,
    refetchLocalList,
  } = props;
  const { t } = useTranslation();
  const confirmationKey = t("general.iConfirm");
  const [integration, setIntegration] = useState<any>();
  const [activeContract, setActiveContract] = useState<any>(false);
  const [whatsappNotifSubMenu, setWhatsappNotifSubMenu] = useState(false);
  const [messagingActive, setMessagingActive] = useState(false);
  const [messagingSMSActive, setMessagingSMSActive] = useState(false);
  const [messagingWhatsappActive, setMessagingWhatsappActive] = useState(false);
  const [messagingWhatsappOpening, setMessagingWhatsappOpening] =
    useState(false);
  const [messagingWhatsappComplete, setMessaggingWhatsappComplete] =
    useState(false);
  const {
    data: dataModules,
    refetch: refetchDataModules,
    isFetching: isFetchingModules,
  } = useQuery<any>(
    ["getmodules", local_key],
    () =>
      fetchAllModules(local_key).then((data: any) => {
        const moduleFinded = data?.modules?.find(
          (module: any) => module?.id === moduleId.contract
        );
        if (moduleFinded && moduleFinded.active) {
          setActiveContract(true);
        } else {
          setActiveContract(false);
        }
        return data;
      }),
    {
      enabled: local_key !== null,
    }
  );
  const [modalView, setModalView] = useState<ModalView>({
    id: null,
    confirmValue: "",
    active: false,
    price: 0,
    defaultPrice: 0,
    priceCycles: 999,
  });
  const activateMutation = useMutation(
    (data: { local_keys: string[]; module_id: number }) =>
      activateModule(data.local_keys, data.module_id),
    {
      onSuccess: () => {
        window.dataLayer.push({
          event: "modulo_attivato_prenotazioni",
          gtm: {
            id_modulo: modalView.id,
            value: modalView.price
              ? modalView.price > 0
                ? (modalView.price / 100).toFixed(2)
                : (modalView.defaultPrice / 100).toFixed(2)
              : (modalView.defaultPrice / 100).toFixed(2),
          },
        });
        toast.success(t("general.requestCompleted"));
        refetchDataModules();
        setModalView({
          id: null,
          confirmValue: "",
          active: false,
          price: 0,
          defaultPrice: 0,
          priceCycles: 999,
        });
      },
      onError: (error: Error) => {
        toast.error(t("general.requestError"));
      },
    }
  );
  const openModalView = (idMod: number) => {
    console.log("setting open ", idMod);
    const data = dataModules.modules.find((mod: any) => mod.id === idMod);
    const price = data.self_price;
    const defaultPrice = data.default_price;
    window.dataLayer.push({
      event: "clic_attiva_modulo_prenotazioni",
      gtm: {
        id_modulo: idMod,
        location: data.results?.country_code?.toLowerCase(),
        value:
          price !== null
            ? price >= 0
              ? (price / 100).toFixed(2)
              : (defaultPrice / 100).toFixed(2)
            : (defaultPrice / 100).toFixed(2),
      },
    });

    setModalView((prev) => {
      return {
        ...prev,
        id: idMod,
        price: price,
        defaultPrice: defaultPrice,
        priceCycles: data.self_price_cycles,
      };
    });
    console.log("modal view ", modalView);
  };
  const { refetch, isLoading: isLoadingSetting } = useQuery(
    ["settingsChannex", rate_plan_id],
    () => fetchSettingsLocalChannex(rate_plan_id),
    {
      enabled:
        (rate_plan_id !== null || rate_plan_id !== undefined) && !!onGoBack,
      onSuccess: (data) => {
        setIntegration({
          ...data.results,
          integr_chk_paystay_filterchannel: data.results
            .integr_chk_paystay_filterchannel
            ? JSON.parse(data.results.integr_chk_paystay_filterchannel)
            : null,
          integr_chk_citytax_filterchannel: data.results
            .integr_chk_citytax_filterchannel
            ? JSON.parse(data.results.integr_chk_citytax_filterchannel)
            : null,
          integr_chk_deposit_filterchannel: data.results
            .integr_chk_deposit_filterchannel
            ? JSON.parse(data.results.integr_chk_deposit_filterchannel)
            : null,
          integr_chk_asknumguests_filterchannel: data.results
            .integr_chk_asknumguests_filterchannel
            ? JSON.parse(data.results.integr_chk_asknumguests_filterchannel)
            : null,
          integr_avoid_add_filterchannel: data.results
            .integr_avoid_add_filterchannel
            ? JSON.parse(data.results.integr_avoid_add_filterchannel)
            : null,
        });
      },
    }
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data: settingsDef } = useQuery<any>(
    ["settingsDef", local_key],
    () => fetchApartmentSettings(local_key as string),
    {
      enabled: local_key !== null && !onGoBack,
      onSuccess: (data) => {
        const result = data.result;
        setIntegration((prev: any) => {
          return {
            ...prev,
            integr_time_checkin: result.time_checkin ?? "15:00",
            integr_time_checkout: result.time_checkout ?? "10:00",
            integr_chk_asknumguests: result.chk_asknumguests,
            integr_chk_contract: result.chk_contract,
            integr_chk_documents: result.chk_documents,
            integr_chk_invoice: result.require_invoice,
            integr_chk_mail: result.chk_mail,
            integr_notify_mail_guest_active: result.notify_mail_guest_active,
            integr_chk_sms: result.chk_sms,
            integr_chk_sms_done: result.chk_sms_done,
            integr_chk_whatsapp: result.chk_whatsapp,
            integr_chk_whatsapp_done: result.chk_whatsapp_done,
            integr_chk_otp: result.chk_otp,
            integr_chk_photo: result.chk_photo,
            integr_chk_photo_all: result.chk_photo_all,
            integr_chk_cc: result.chk_cc,
            integr_chk_citytax: result.chk_citytax,
            integr_chk_paystay: result.chk_paystay,
            integr_chk_deposit: result.chk_deposit,
            integr_deposit_amount: result.deposit_amount ?? 0,
            integr_cust_contract_ptr: result.cust_contract_ptr ?? 0,
            integr_cust_checkin_ptr: result.cust_checkin_ptr ?? 0,
            integr_cust_email_ptr: result.cust_email_ptr ?? 0,
            integr_notify_now: result.notify_now,
            integr_notify_7days: result.notify_7days,
            integr_notify_3days: result.notify_3days,
            integr_notify_1days: result.notify_1days,
            integr_notify_checkout: result.notify_checkout,
            integr_notify_done_1days: result.notify_done_1days,
            integr_wapp_notify_now: result.integr_wapp_notify_now,
            integr_wapp_notify_7days: result.integr_wapp_notify_7days,
            integr_wapp_notify_3days: result.integr_wapp_notify_3days,
            integr_wapp_notify_1days: result.integr_wapp_notify_1days,
            integr_wapp_notify_checkout: result.integr_wapp_notify_checkout,
            integr_chk_docs_auto_confirmation:
              result.integr_chk_docs_auto_confirmation,
            integr_chk_citytax_chargeguest: result.chk_citytax_chargeguest,
            integr_chk_paystay_chargeguest: result.chk_paystay_chargeguest,
            integr_chk_deposit_chargeguest: result.chk_deposit_chargeguest,
          };
        });
      },
    }
  );

  const { data: checkInTemplates, isFetching: fetchingCheckInTemplates } =
    useQuery(["checkInTemplates", local_key], () => fetchCustomCheckins(), {
      enabled: local_key !== null,
    });

  const { data: emailTemplates, isFetching: fetchingEmailTemplates } = useQuery(
    ["emailTemplates", local_key],
    () => fetchCustomEmails(local_key ? local_key : undefined, true),
    {
      enabled: local_key !== null,
    }
  );

  const { data: contracts, isFetching: fetchingContracts } = useQuery(
    ["contracts", local_key],
    () => fetchContracts(local_key ? local_key : undefined, true),
    {
      enabled: local_key !== null && local_key !== undefined,
    }
  );
  const { data: apartmentDetail } = useQuery(
    ["apartmentDetail", local_key],
    () =>
      fetchV3AllLocals().then((data) =>
        data.results?.find((local) => local.local_key === local_key)
      ),
    {
      enabled: local_key !== null && local_key !== undefined,
    }
  );

  const editRoomVikeySettings = useMutation(
    (data: any) =>
      putSettingsLocalChannex({ channex_rate_plan_id: rate_plan_id, ...data }),
    {
      onSuccess: () => {
        toast.success(t("general.requestCompleted"));
        refetch();
        if (refetchLocalList) refetchLocalList();
        if (onGoBack) onGoBack();
        if (onSuccessMutation) onSuccessMutation();
      },
    }
  );

  useEffect(() => {
    checkInTemplates?.results?.push({ objkey: "Vikey Default", id: 0 });
  }, [checkInTemplates]);

  useEffect(() => {
    emailTemplates?.results?.push({ objkey: "Vikey Default", id: 0 });
  }, [emailTemplates]);
  useEffect(() => {
    if (
      integration &&
      (integration.integr_wapp_notify_now ||
        integration.integr_wapp_notify_7days ||
        integration.integr_wapp_notify_3days ||
        integration.integr_wapp_notify_1days ||
        integration.integr_chk_whatsapp_done ||
        integration.integr_wapp_notify_checkout)
    ) {
      setWhatsappNotifSubMenu(true);
    }
  }, [integration]);
  useEffect(() => {
    dataModules?.modules?.map((module: any) => {
      // console.log("module ", module, module.active);
      if (module.id === moduleId.sms && module.active) {
        setMessagingSMSActive(true);
      } else if (module.id === moduleId.whatsapp && module.active) {
        setMessagingWhatsappActive(true);
      } else if (module.id === moduleId.sms_whatsapp && module.active) {
        setMessagingSMSActive(true);
        setMessagingWhatsappActive(true);
      } else if (module.id === moduleId.whatsapp_complete && module.active) {
        setMessagingSMSActive(true);
        setMessagingWhatsappActive(true);
      }

      if (module.id === moduleId.sms_done && module.active) {
        setMessagingActive(module.active);
      } else if (module.id === moduleId.whatsapp_done) {
        setMessagingWhatsappOpening(module.active);
      } else if (module.id === moduleId.sms_whatssapp_done && module.active) {
        setMessagingActive(module.active);
        setMessagingWhatsappOpening(module.active);
      } else if (module.id === moduleId.whatsapp_complete && module.active) {
        setMessagingActive(module.active);
        setMessagingWhatsappOpening(module.active);
      }
      if (module.id === moduleId.whatsapp_complete && module.active) {
        setMessaggingWhatsappComplete(module.active);
      }
    });
  }, [dataModules, local_key]);
  useEffect(() => {
    console.log(
      messagingSMSActive,
      messagingActive,
      messagingWhatsappComplete,
      messagingWhatsappOpening
    );
  }, [
    messagingSMSActive,
    messagingActive,
    messagingWhatsappComplete,
    messagingWhatsappOpening,
  ]);
  return (
    <div className="md:text-sm text-xs md:p-0 p-3">
      {onGoBack && (
        <div className="mb-5">
          <Icon
            name="arrow-narrow-left"
            size="18px"
            onClick={() => {
              onGoBack();
            }}
            className="cursor-pointer"
          />
          {t("general.goBack")}
        </div>
      )}
      <div className="flex flex-col lg:flex-row lg:space-x-4 space-y-4 lg:space-y-0">
        <div className={"flex-1"}>
          <FormField label={t("resv.checkInTime")}>
            <SelectInput<BaseSelectItem, false>
              isDisabled={isLoadingSetting}
              isLoading={isLoadingSetting}
              menuShouldScrollIntoView={false}
              menuPortalTarget={document.body}
              styles={{
                container: (base) => ({ ...base, zIndex: 999 }),
                menuPortal: (base) => ({ ...base, zIndex: 999 }),
              }}
              value={{
                label: integration?.integr_time_checkin
                  ? integration?.integr_time_checkin.slice(0, 5)
                  : "15:00",
                value: integration?.integr_time_checkin
                  ? integration?.integr_time_checkin.slice(0, 5)
                  : "15:00",
              }}
              onChange={(item) => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_time_checkin: item ? item.value : "15:00",
                  };
                });
              }}
              options={times}
            />
          </FormField>
        </div>

        <div className={"flex-1"}>
          <FormField label={t("resv.checkOutTime")}>
            <SelectInput<BaseSelectItem, false>
              isDisabled={isLoadingSetting}
              isLoading={isLoadingSetting}
              menuShouldScrollIntoView={false}
              menuPortalTarget={document.body}
              styles={{
                container: (base) => ({ ...base, zIndex: 999 }),
                menuPortal: (base) => ({ ...base, zIndex: 999 }),
              }}
              value={{
                label: integration?.integr_time_checkout
                  ? integration?.integr_time_checkout.slice(0, 5)
                  : "10:00",
                value: integration?.integr_time_checkout
                  ? integration?.integr_time_checkout.slice(0, 5)
                  : "10:00",
              }}
              onChange={(item) => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_time_checkout: item ? item.value : "10:00",
                  };
                });
              }}
              options={times}
            />
          </FormField>
        </div>
      </div>

      <FormField label={t("resv.onlineCheckIn")} className="mt-4">
        <SelectInput<BaseSelectItem, false>
          isDisabled={isLoadingSetting}
          isLoading={isLoadingSetting || fetchingCheckInTemplates}
          styles={{
            container: (base) => ({ ...base, zIndex: 999 }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuShouldScrollIntoView={false}
          menuPortalTarget={document.body}
          value={getOptionList(checkInTemplates?.results, "objkey", "id").find(
            (item) => item.value === integration?.integr_cust_checkin_ptr
          )}
          onChange={(item) => {
            if (item) {
              setIntegration((prev: any) => {
                return {
                  ...prev,
                  integr_cust_checkin_ptr: item.value,
                };
              });
            }
          }}
          options={getOptionList(checkInTemplates?.results, "objkey", "id")}
        />
      </FormField>

      <FormField label={t("reservations.color")} className="mt-4">
        <div className="flex space-x-2">
          {[
            { label: "White", color: "bg-gray-200", value: 1 },
            { label: "Green", color: "bg-green-600", value: 2 },
            { label: "Blue", color: "bg-blue-600", value: 3 },
            { label: "Yellow", color: "bg-yellow-300", value: 4 },
            { label: "Orange", color: "bg-yellow-600", value: 5 },
            { label: "Red", color: "bg-red-600", value: 6 },
          ].map((color) => (
            <button
              key={color.value}
              onClick={() => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_mark: color.value,
                  };
                });
              }}
              className={`transition-all ${color.color} w-5 h-5 rounded-2xl ${
                integration?.integr_mark !== color.value && `opacity-40`
              } ${
                integration?.integr_mark === color.value &&
                `ring-4 ring-${color.color}-200`
              }`}
            ></button>
          ))}
        </div>
      </FormField>

      <div className="font-medium md:text-lg text-md pt-4">Features</div>

      <div>
        <div className="flex items-center space-x-2">
          <Checkbox
            label={`${t("resv.sendRemindSMS")}`}
            disabled={!messagingSMSActive || isLoadingSetting}
            loading={isLoadingSetting}
            onChange={() => {
              setIntegration((prev: any) => {
                return {
                  ...prev,
                  integr_chk_sms: !integration?.integr_chk_sms,
                };
              });
            }}
            checked={
              integration?.integr_chk_sms === 0
                ? false
                : integration?.integr_chk_sms
            }
          />
          {!messagingSMSActive && local_key && (
            <Button
              label={t("apartmentSettings.activeModule")}
              className="bg-activateModule"
              size="small"
              onClick={() => openModalView(moduleId.whatsapp_complete)}
            />
          )}
        </div>

        {!messagingWhatsappComplete && (
          <div className="flex items-center space-x-2 my-2">
            <Checkbox
              label={`${t("resv.sendRemindWHATSAPP")}`}
              disabled={!messagingWhatsappActive || isLoadingSetting}
              loading={isLoadingSetting}
              onChange={() => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_chk_whatsapp: !integration?.integr_chk_whatsapp,
                  };
                });
              }}
              checked={
                integration?.integr_chk_whatsapp === 0
                  ? false
                  : integration?.integr_chk_whatsapp
              }
            />
            {!messagingWhatsappActive && local_key && (
              <Button
                label={t("apartmentSettings.activeModule")}
                className="bg-activateModule"
                size="small"
                onClick={() => openModalView(moduleId.whatsapp_complete)}
              />
            )}
          </div>
        )}

        <div className="flex items-center space-x-2 my-2">
          <Checkbox
            label={`${t("resv.sendRemindSMSdone")}`}
            disabled={!messagingActive || isLoadingSetting}
            loading={isLoadingSetting}
            onChange={() => {
              setIntegration((prev: any) => {
                return {
                  ...prev,
                  integr_chk_sms_done: !integration?.integr_chk_sms_done,
                };
              });
            }}
            checked={
              integration?.integr_chk_sms_done === 0
                ? false
                : integration?.integr_chk_sms_done
            }
          />
          {!messagingActive && local_key && (
            <Button
              label={t("apartmentSettings.activeModule")}
              className="bg-activateModule"
              size="small"
              onClick={() => openModalView(moduleId.whatsapp_complete)}
            />
          )}
        </div>

        {!messagingWhatsappComplete && (
          <div className="flex items-center space-x-2 my-2">
            <Checkbox
              label={`${t("resv.sendRemindWHATSAPPdone")}`}
              disabled={!messagingWhatsappOpening}
              loading={isLoadingSetting}
              onChange={() => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_chk_whatsapp_done: !prev?.integr_chk_whatsapp_done,
                  };
                });
              }}
              checked={
                integration?.integr_chk_whatsapp_done === 0
                  ? false
                  : integration?.integr_chk_whatsapp_done
              }
            />
            {!messagingWhatsappOpening && local_key && (
              <Button
                label={t("apartmentSettings.activeModule")}
                className="bg-activateModule"
                size="small"
                onClick={() => openModalView(moduleId.whatsapp_complete)}
              />
            )}
          </div>
        )}

        <Checkbox
          label={t("resv.enableEmail")}
          onChange={() => {
            setIntegration((prev: any) => {
              if (prev.integr_chk_mail) {
                return {
                  ...prev,
                  integr_chk_mail: false,
                  integr_cust_email_ptr: false,
                  integr_chk_cc: false,
                  integr_notify_now: false,
                  integr_notify_7days: false,
                  integr_notify_3days: false,
                  integr_notify_1days: false,
                  integr_notify_done_1days: false,
                  integr_notify_checkout: false,
                };
              }
              return {
                ...prev,
                integr_chk_mail: true,
              };
            });
          }}
          checked={
            integration?.integr_chk_mail === 0
              ? false
              : integration?.integr_chk_mail
          }
          disabled={isLoadingSetting}
          loading={isLoadingSetting}
        />

        {integration?.integr_chk_mail && (
          <div className="bg-gray-100 border rounded-2xl p-4 mb-2">
            <SelectInput<BaseSelectItem, false>
              styles={{
                container: (base) => ({ ...base, zIndex: 999 }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuShouldScrollIntoView={false}
              menuPortalTarget={document.body}
              isDisabled={isLoadingSetting}
              isLoading={fetchingEmailTemplates || isLoadingSetting}
              value={getOptionList(
                emailTemplates?.results,
                "objkey",
                "id"
              ).find(
                (item) => item.value === integration?.integr_cust_email_ptr
              )}
              onChange={(item) => {
                if (item) {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_cust_email_ptr: item.value,
                    };
                  });
                }
              }}
              options={getOptionList(emailTemplates?.results, "objkey", "id")}
            />

            <div className="mt-4">
              <Checkbox
                label={t("resv.enableCCEmail")}
                checked={
                  integration?.integr_chk_cc === 0
                    ? false
                    : integration?.integr_chk_cc
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_chk_cc: !prev.integr_chk_cc,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />

              <Checkbox
                label={t("resv.createNotification")}
                checked={
                  integration?.integr_notify_now === 0
                    ? false
                    : integration?.integr_notify_now
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_notify_now: !prev.integr_notify_now,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />

              <Checkbox
                label={t("resv.sevenDayNotification")}
                checked={
                  integration?.integr_notify_7days === 0
                    ? false
                    : integration?.integr_notify_7days
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_notify_7days: !prev?.integr_notify_7days,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />

              <Checkbox
                label={t("resv.threeDayNotification")}
                checked={
                  integration?.integr_notify_3days === 0
                    ? false
                    : integration?.integr_notify_3days
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_notify_3days: !prev?.integr_notify_3days,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />

              <Checkbox
                label={t("resv.oneDayNotification")}
                checked={
                  integration?.integr_notify_1days === 0
                    ? false
                    : integration?.integr_notify_1days
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_notify_1days: !prev?.integr_notify_1days,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />

              <Checkbox
                label={t("resv.completeNotification")}
                checked={
                  integration?.integr_notify_done_1days === 0
                    ? false
                    : integration?.integr_notify_done_1days
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_notify_done_1days: !prev?.integr_notify_done_1days,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />

              <Checkbox
                label={t("resv.checkoutNotification")}
                checked={
                  integration?.integr_notify_checkout === 0
                    ? false
                    : integration?.integr_notify_checkout
                }
                onChange={() => {
                  setIntegration((prev: any) => {
                    return {
                      ...prev,
                      integr_notify_checkout: !prev?.integr_notify_checkout,
                    };
                  });
                }}
                disabled={isLoadingSetting}
                loading={isLoadingSetting}
              />
            </div>
          </div>
        )}
        <div className="space-y-2">
          {dataModules?.modules?.map((module: any) => {
            if (module.id === moduleId.whatsapp_complete) {
              return (
                <div key={module.id} className="flex items-center gap-4">
                  <Checkbox
                    label={t("resv.enableResvWappNotifs")}
                    onChange={() => {
                      setIntegration((prev: any) => {
                        if (whatsappNotifSubMenu) {
                          return {
                            ...prev,
                            integr_wapp_notify_now: false,
                            integr_wapp_notify_7days: false,
                            integr_wapp_notify_3days: false,
                            integr_wapp_notify_1days: false,
                            integr_chk_whatsapp_done: false,
                            integr_wapp_notify_checkout: false,
                          };
                        } else {
                          return {
                            ...prev,
                          };
                        }
                      });
                      setWhatsappNotifSubMenu(!whatsappNotifSubMenu);
                    }}
                    checked={
                      whatsappNotifSubMenu ||
                      (integration &&
                        (integration.integr_wapp_notify_now ||
                          integration.integr_wapp_notify_7days ||
                          integration.integr_wapp_notify_3days ||
                          integration.integr_wapp_notify_1days ||
                          integration.integr_chk_whatsapp_done ||
                          integration.integr_wapp_notify_checkout))
                    }
                    disabled={
                      !dataModules?.modules?.some(
                        (module: any) =>
                          module.id === moduleId.whatsapp_complete &&
                          module.active
                      )
                    }
                    loading={isFetchingModules}
                  />
                  {!module.active && (
                    <Button
                      label={t("apartmentSettings.activeModule")}
                      className="bg-activateModule"
                      size="small"
                      onClick={() => openModalView(moduleId.whatsapp_complete)}
                    />
                  )}
                </div>
              );
            }
            return null;
          })}
        </div>

        {whatsappNotifSubMenu &&
          !isFetchingModules &&
          dataModules?.modules?.some(
            (module: any) =>
              module.id === moduleId.whatsapp_complete && module.active
          ) && (
            <div className="bg-gray-100 border rounded-2xl p-4 mb-2">
              <div className="mt-4">
                <Checkbox
                  label={t("resv.createNotification")}
                  checked={
                    integration.integr_wapp_notify_now === 0
                      ? false
                      : integration.integr_wapp_notify_now
                  }
                  onChange={() => {
                    setIntegration({
                      ...integration,
                      integr_wapp_notify_now:
                        !integration.integr_wapp_notify_now,
                    });
                  }}
                />

                <Checkbox
                  label={t("resv.sevenDayNotification")}
                  checked={integration.integr_wapp_notify_7days}
                  onChange={() => {
                    setIntegration({
                      ...integration,
                      integr_wapp_notify_7days:
                        !integration.integr_wapp_notify_7days,
                    });
                  }}
                />

                <Checkbox
                  label={t("resv.threeDayNotification")}
                  checked={integration.integr_wapp_notify_3days}
                  onChange={() => {
                    setIntegration({
                      ...integration,
                      integr_wapp_notify_3days:
                        !integration.integr_wapp_notify_3days,
                    });
                  }}
                />

                <Checkbox
                  label={t("resv.oneDayNotification")}
                  checked={integration.integr_wapp_notify_1days}
                  onChange={() => {
                    setIntegration({
                      ...integration,
                      integr_wapp_notify_1days:
                        !integration.integr_wapp_notify_1days,
                    });
                  }}
                />

                <Checkbox
                  label={t("resv.sendRemindWHATSAPPdone")}
                  checked={
                    integration.integr_chk_whatsapp_done === 0
                      ? false
                      : integration.integr_chk_whatsapp_done
                  }
                  onChange={() => {
                    setIntegration({
                      ...integration,
                      integr_chk_whatsapp_done:
                        !integration.integr_chk_whatsapp_done,
                    });
                  }}
                />

                <Checkbox
                  label={t("resv.wappCheckoutNotification")}
                  checked={
                    integration.integr_wapp_notify_checkout === 0
                      ? false
                      : integration.integr_wapp_notify_checkout
                  }
                  onChange={() => {
                    setIntegration({
                      ...integration,
                      integr_wapp_notify_checkout:
                        !integration.integr_wapp_notify_checkout,
                    });
                  }}
                />
              </div>
            </div>
          )}

        <Checkbox
          label={t("resv.enableGuestActive")}
          onChange={() => {
            setIntegration((prev: any) => {
              return {
                ...prev,
                integr_notify_mail_guest_active:
                  !prev?.integr_notify_mail_guest_active,
              };
            });
          }}
          checked={
            integration?.integr_notify_mail_guest_active === 0
              ? false
              : integration?.integr_notify_mail_guest_active
          }
          disabled={isLoadingSetting}
          loading={isLoadingSetting}
        />

        <PaystaySelector
          local={apartmentDetail as LocalTable}
          integration={integration}
          setIntegration={setIntegration}
        />
        {dataModules?.modules?.map((module: any) => {
          if (module.id === moduleId.deposit) {
            return (
              <DepositSelector
                local={apartmentDetail as LocalTable}
                integration={integration}
                setIntegration={setIntegration}
              />
            );
          }
          return null;
        })}

        <CitytaxSelector
          local={apartmentDetail as LocalTable}
          integration={integration}
          setIntegration={setIntegration}
        />

        <DocumentSelector
          local={apartmentDetail as LocalTable}
          integration={integration}
          setIntegration={setIntegration}
        />

        <Checkbox
          label={t("resv.mandatoryContractSign")}
          disabled={
            !contracts ||
            (contracts?.results &&
              contracts.results.length <= 0 &&
              !integration?.integr_chk_contract) ||
            (!activeContract && !integration?.integr_chk_contract)
          }
          loading={isLoadingSetting}
          onChange={() => {
            setIntegration((prev: any) => {
              return {
                ...prev,
                integr_chk_contract: !prev?.integr_chk_contract,
              };
            });
          }}
          checked={
            integration?.integr_chk_contract === 0
              ? false
              : integration?.integr_chk_contract
          }
        />

        {integration?.integr_chk_contract && (
          <div className="bg-gray-100 border rounded-2xl p-4 pb-2 mb-2">
            <FormField label={t("resv.contract")}>
              <SelectInput<BaseSelectItem, false>
                menuShouldScrollIntoView={false}
                menuPortalTarget={document.body}
                styles={{
                  container: (base) => ({ ...base, zIndex: 999 }),
                  menuPortal: (base) => ({ ...base, zIndex: 999 }),
                }}
                isDisabled={isLoadingSetting}
                isLoading={fetchingContracts || isLoadingSetting}
                value={getOptionList(contracts?.results, "objkey", "id").find(
                  (item) => item.value === integration?.integr_cust_contract_ptr
                )}
                options={getOptionList(contracts?.results, "objkey", "id")}
                onChange={(item) => {
                  if (item) {
                    setIntegration((prev: any) => {
                      return {
                        ...prev,
                        integr_cust_contract_ptr: item.value,
                      };
                    });
                  }
                }}
              />
            </FormField>

            <Checkbox
              className={"mt-4"}
              label={t("resv.requestOTP")}
              onChange={() => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_chk_otp: !integration?.integr_chk_otp,
                  };
                });
              }}
              checked={
                integration?.integr_chk_otp === 0
                  ? false
                  : integration?.integr_chk_otp
              }
              disabled={isLoadingSetting}
              loading={isLoadingSetting}
            />
          </div>
        )}

        <Checkbox
          label={t("resv.requestInvoice")}
          onChange={() => {
            setIntegration((prev: any) => {
              return {
                ...prev,
                integr_chk_invoice: !prev?.integr_chk_invoice,
              };
            });
          }}
          checked={
            integration?.integr_chk_invoice === 0
              ? false
              : integration?.integr_chk_invoice
          }
          disabled={isLoadingSetting}
          loading={isLoadingSetting}
        />
        <div className="bg-gray-50 border rounded-2xl p-4 pb-2 mb-2">
          <FormField label={t("integration.avoidAdd")}>
            <Checkbox
              label={"Airbnb"}
              onChange={() => {
                setIntegration((prev: any) => {
                  return {
                    ...prev,
                    integr_avoid_add_filterchannel: {
                      EXPEDIA:
                        integration.integr_avoid_add_filterchannel?.EXPEDIA ??
                        false,
                      BOOKING:
                        integration.integr_avoid_add_filterchannel?.BOOKING ??
                        false,
                      OTHER:
                        integration.integr_avoid_add_filterchannel?.OTHER ??
                        false,
                      AIRBNB: !prev?.integr_avoid_add_filterchannel?.AIRBNB,
                    },
                  };
                });
              }}
              checked={
                integration?.integr_avoid_add_filterchannel?.AIRBNB === 0
                  ? false
                  : integration?.integr_avoid_add_filterchannel?.AIRBNB
              }
              disabled={isLoadingSetting}
              loading={isLoadingSetting}
            />
          </FormField>
        </div>
      </div>
      <div className="text-center">
        <Button
          padding={"md"}
          size={"small"}
          label={t("general.save")}
          onClick={() => {
            const dataToSend = {
              ...integration,
              integr_chk_citytax_chargeguest: integration.integr_chk_citytax
                ? integration.integr_chk_citytax_chargeguest
                : false,
              integr_chk_citytax_filterchannel: integration.integr_chk_citytax
                ? JSON.stringify({
                    EXPEDIA:
                      integration.integr_chk_citytax_filterchannel?.EXPEDIA ??
                      false,
                    BOOKING:
                      integration.integr_chk_citytax_filterchannel?.BOOKING ??
                      false,
                    AIRBNB:
                      integration.integr_chk_citytax_filterchannel?.AIRBNB ??
                      false,
                    OTHER:
                      integration.integr_chk_citytax_filterchannel?.OTHER ??
                      false,
                  })
                : JSON.stringify({
                    EXPEDIA: false,
                    BOOKING: false,
                    AIRBNB: false,
                    OTHER: false,
                  }),
              integr_chk_paystay_chargeguest: integration.integr_chk_paystay
                ? integration.integr_chk_paystay_chargeguest
                : false,
              integr_chk_paystay_filterchannel: integration.integr_chk_paystay
                ? JSON.stringify({
                    EXPEDIA:
                      integration.integr_chk_paystay_filterchannel?.EXPEDIA ??
                      false,
                    BOOKING:
                      integration.integr_chk_paystay_filterchannel?.BOOKING ??
                      false,
                    AIRBNB:
                      integration.integr_chk_paystay_filterchannel?.AIRBNB ??
                      false,
                    OTHER:
                      integration.integr_chk_paystay_filterchannel?.OTHER ??
                      false,
                  })
                : JSON.stringify({
                    EXPEDIA: false,
                    BOOKING: false,
                    AIRBNB: false,
                    OTHER: false,
                  }),
              integr_chk_deposit_chargeguest: integration.integr_chk_deposit
                ? integration.integr_chk_deposit_chargeguest
                : false,
              integr_chk_deposit_filterchannel: integration.integr_chk_deposit
                ? JSON.stringify({
                    EXPEDIA:
                      integration.integr_chk_deposit_filterchannel?.EXPEDIA ??
                      false,
                    BOOKING:
                      integration.integr_chk_deposit_filterchannel?.BOOKING ??
                      false,
                    AIRBNB:
                      integration.integr_chk_deposit_filterchannel?.AIRBNB ??
                      false,
                    OTHER:
                      integration.integr_chk_deposit_filterchannel?.OTHER ??
                      false,
                  })
                : JSON.stringify({
                    EXPEDIA: false,
                    BOOKING: false,
                    AIRBNB: false,
                    OTHER: false,
                  }),
              integr_chk_photo: integration.integr_chk_documents
                ? integration.integr_chk_photo
                : false,
              integr_chk_docs_auto_confirmation:
                integration.integr_chk_documents
                  ? integration.integr_chk_docs_auto_confirmation
                  : false,
              integr_chk_photo_all: integration.integr_chk_documents
                ? integration.integr_chk_photo_all
                : false,
              integr_chk_asknumguests: integration.integr_chk_documents
                ? integration.integr_chk_asknumguests
                : false,
              integr_chk_asknumguests_filterchannel:
                integration.integr_chk_documents
                  ? JSON.stringify({
                      EXPEDIA:
                        integration.integr_chk_asknumguests_filterchannel
                          ?.EXPEDIA ?? false,
                      BOOKING:
                        integration.integr_chk_asknumguests_filterchannel
                          ?.BOOKING ?? false,
                      AIRBNB:
                        integration.integr_chk_asknumguests_filterchannel
                          ?.AIRBNB ?? false,
                      OTHER:
                        integration.integr_chk_asknumguests_filterchannel
                          ?.OTHER ?? false,
                    })
                  : JSON.stringify({
                      EXPEDIA: false,
                      BOOKING: false,
                      AIRBNB: false,
                      OTHER: false,
                    }),
              integr_avoid_add_filterchannel:
                integration.integr_avoid_add_filterchannel
                  ? JSON.stringify({
                      AIRBNB:
                        integration.integr_avoid_add_filterchannel?.AIRBNB ??
                        false,
                      EXPEDIA:
                        integration.integr_avoid_add_filterchannel?.EXPEDIA ??
                        false,
                      BOOKING:
                        integration.integr_avoid_add_filterchannel?.BOOKING ??
                        false,
                      OTHER:
                        integration.integr_avoid_add_filterchannel?.OTHER ??
                        false,
                    })
                  : JSON.stringify({
                      EXPEDIA: false,
                      BOOKING: false,
                      OTHER: false,
                      AIRBNB: false,
                    }),
              integr_chk_otp: integration.integr_chk_contract
                ? integration.integr_chk_otp
                : false,
              integr_cust_contract_ptr: integration.integr_chk_contract
                ? integration.integr_cust_contract_ptr
                : 0,
              integr_cust_email_ptr: integration.integr_chk_mail
                ? integration.integr_cust_email_ptr
                : 0,
              integr_chk_cc: integration.integr_chk_mail
                ? integration.integr_chk_cc
                : 0,
              integr_notify_now: integration.integr_chk_mail
                ? integration.integr_notify_now
                : 0,
              integr_notify_7days: integration.integr_chk_mail
                ? integration.integr_notify_7days
                : 0,
              integr_notify_3days: integration.integr_chk_mail
                ? integration.integr_notify_3days
                : 0,
              integr_notify_1days: integration.integr_chk_mail
                ? integration.integr_notify_1days
                : 0,
              integr_notify_done_1days: integration.integr_chk_mail
                ? integration.integr_notify_done_1days
                : 0,
              integr_notify_checkout: integration.integr_chk_mail
                ? integration.integr_notify_checkout
                : 0,
              integr_time_checkin: integration.integr_time_checkin
                ? integration.integr_time_checkin
                : "15:00",
              integr_time_checkout: integration.integr_time_checkout
                ? integration.integr_time_checkout
                : "10:00",
            };
            delete dataToSend.date_creation;
            delete dataToSend.date_updated;
            editRoomVikeySettings.mutate(dataToSend);
          }}
          disabled={editRoomVikeySettings.isLoading}
          loading={editRoomVikeySettings.isLoading}
        />
      </div>
      <Modal visible={!!modalView.id}>
        <ModalCard
          title={`${t("apartmentSettings.activeModule").toUpperCase()} - ${t(
            `module.id${modalView.id}`
          ).toUpperCase()}`}
          className="w-full"
        >
          <ModalSection>
            <div className="text-gray-700 p-4 pt-0 border-gray-300">
              <ModuleCard
                moduleName={t(`module.id${modalView.id}`).toUpperCase()}
                active={modalView.active}
                price={modalView.price}
                defaultPrice={modalView.defaultPrice}
                onChange={() => {
                  setModalView((prev) => {
                    if (prev.active) {
                      return {
                        ...prev,
                        active: !prev.active,
                        confirmValue: "",
                      };
                    }
                    return {
                      ...prev,
                      active: !prev.active,
                    };
                  });
                }}
                priceCycles={modalView.priceCycles}
              />
            </div>
            {modalView.active && (
              <div className="text-gray-700 p-4 pt-0 border-gray-300">
                {t("general.write1")}
                <span className={"font-bold"}>{confirmationKey}</span>{" "}
                {t("general.write2")}
                <div className="mt-2">
                  <TextInput
                    value={modalView.confirmValue}
                    onChange={(val) =>
                      setModalView((prev) => {
                        return {
                          ...prev,
                          confirmValue: val,
                        };
                      })
                    }
                  />
                </div>
              </div>
            )}
          </ModalSection>
          <ModalActions
            isLoading={activateMutation.isLoading}
            onSave={() => {
              if (modalView.confirmValue === confirmationKey && local_key) {
                activateMutation.mutate({
                  local_keys: [local_key],
                  module_id: modalView.id as number,
                });
              }
            }}
            saveLabel={t("general.enable")}
            saveDisabled={modalView.confirmValue !== confirmationKey}
            onClose={() => {
              setModalView({
                id: null,
                confirmValue: "",
                active: false,
                price: 0,
                defaultPrice: 0,
                priceCycles: 999,
              });
            }}
          />
        </ModalCard>
      </Modal>
    </div>
  );
};

export default EditRoomSettings;
